module.exports = __webpack_public_path__ + "img/FroSmokes@3x.4fdcb5d0.webp";